import { clientApi } from 'shared/api/clientApi'

import type { SearchPresetResponse } from './model'

export const KyrgyzstanSearchPresetsApi = {
  getPresets() {
    return clientApi.get<SearchPresetResponse>(
      '/kyrgyzstan/search-presets/presets',
    )
  },
}
